import { useEffect, FC, PropsWithChildren } from 'react';
import { useLocalStorageState, useMount } from '@fuxi/eevee-hooks';
import { useAppDispatch } from '@tiangong/hooks';
import { camelToKebab } from '@tiangong/utils';

import { DEFAULT_THEME, LocalStorageKey } from 'common/types';
import { LightTheme, DarkTheme, ComponentsTheme } from 'common/styles/antd-theme';
import { setTheme as setThemeStore } from '@tiangong/store/theme';

import { ConfigProvider, theme as antTheme, App, FloatButton } from '@fuxi/eevee-ui';
import zhCN from 'antd/es/locale/zh_CN';

const antThemeToCssVars = (antThemeToken) => {
  Object.entries(antThemeToken).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--${camelToKebab(key)}`, value as string);
  });
};

export const TiangongConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();
  const [theme, setTheme] = useLocalStorageState<string | undefined>(LocalStorageKey.TiangongTheme, {
    defaultValue: DEFAULT_THEME,
  });

  const token = Object.assign(theme === 'light' ? { ...LightTheme } : { ...DarkTheme }, {});

  // 切换主题
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    dispatch(setThemeStore(newTheme));
  };

  useEffect(() => {
    const themeVars = theme === 'light' ? { ...LightTheme } : { ...DarkTheme };
    const linkEl = document.querySelector('link[rel="icon"]'); // 获取 link 元素
    const href = theme === 'light' ? '/youLingLight.ico' : '/youLingDark.ico';
    linkEl && Object.assign(linkEl, { href });
    antThemeToCssVars(themeVars);
  }, [theme]);

  useEffect(() => {
    // Setting Modal、Message、Notification static config
    ConfigProvider.config({
      theme: {
        token: token,
      },
    });
  }, [token]);

  useMount(() => {
    theme !== 'dark' && setTheme('dark');
  });

  return (
    <ConfigProvider
      form={{
        colon: false,
      }}
      locale={zhCN}
      theme={{
        cssVar: {
          prefix: '',
        },
        hashed: false,
        token: token,
        algorithm: theme === 'light' ? antTheme.defaultAlgorithm : antTheme.darkAlgorithm,
        components: ComponentsTheme,
      }}>
      <App>
        {/* {import.meta.env.MODE !== 'prod' && <FloatButton className="bg-primary" onClick={toggleTheme} />} */}
        {children}
      </App>
    </ConfigProvider>
  );
};
